export default "__VITE_ASSET__D2$Zy$e3__"